// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3lCzm","linkActive":"_3IDuB","bubble":"nbvT8","collection":"_10b30"};